import React from "react";
import FormSubmissionContainer from "../../../components/client/blitzscalability-form-result/blitzscalability-result";

function renderResults() {
  return <FormSubmissionContainer />;
}

export default renderResults;
